import { useLocation } from 'react-router-dom';

import { Confirm } from '../../ui/reset/Confirm';
import { Request } from '../../ui/reset/Request';
import { View } from '../../ui/View';

const getToken = (search: string) => new URLSearchParams(search).get('token');

export const ResetPasswordPage = () => {
  const location = useLocation();
  const token = getToken(location.search);
  const isConfirmPage = Boolean(token);

  if (isConfirmPage) {
    return (
      <View>
        <Confirm token={token} />
      </View>
    );
  }

  return (
    <View>
      <Request />
    </View>
  );
};
